// BIS draft (Claude): gifts are no longer added automatically. Customers add them via the "Free gift unlocked" block.
// Gifts added by the progress bar (_added_by=progress_bar) are still removed automatically when the cart drops below the threshold.
// 4 Nov 2026 (Claude): the highest gift (toiletry bag, from €175) is only free together with the lower gift (towel, from €100):
// Shopify discount "Free Towel + Toiletry bag" = buy €175, get BOTH free. When the cart is above the highest threshold and
// contains at least one gift, the missing gift(s) are added automatically (_added_by=progress_bar), in both directions
// (towel -> toiletry bag added, toiletry bag -> towel added), so the customer never pays for the toiletry bag (order #37071).
// PLN/CZK/GBP: thresholds use max(display threshold, EUR threshold x live Shopify rate) so the discount minimum is always met.
class TsProgress extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
  }

  async renderProgress() {
    if (!document.querySelector('.cart-drawer-modal').classList.contains('second')) return;
    const cartResponse = await fetch(`${window.Shopify.routes.root}?sections=cart-drawer`);
    const cartData = await cartResponse.json();

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = cartData['cart-drawer'];

    const newUpsell = tempDiv.querySelector('[data-progress]');
    const oldUpsell = document.querySelector('[data-progress]');

    if (newUpsell && oldUpsell) {
      oldUpsell.innerHTML = newUpsell.innerHTML;
    }
  }

  handleProgress() {
    window.setTimeout(() => {
      this.handleAddToCart();
    }, 1000)
  }

  async handleAddToCart() {
    if (!document.querySelector('.cart-drawer-modal').classList.contains('second')) return;
    const steps = this.querySelectorAll('.step');
    const stepData = Array.from(steps)
      .map(step => ({
        id: step.dataset.id?.trim(),
        // BIS: never below the Shopify discount minimum at today's Shopify rate (EUR threshold x live rate).
        threshold: Math.max(Number(step.dataset.trashold) || 0, Math.ceil((Number(step.dataset.eur) || 0) * (Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1)))
      }))
      .filter(step => step.id);

    fetch(`${window.Shopify.routes.root}cart.js`)
      .then(res => res.json())
      .then(cart => {
        const cartItems = cart.items;

        const progressBar = document.querySelector('.progress-bar');
        if (progressBar) {
          progressBar.style.display = cartItems.length === 0 ? 'none' : 'block';
        }

        const progressItems = cartItems.filter(item => item.properties?._added_by === "progress_bar");
        const progressItemsTotal = progressItems.reduce((sum, item) => sum + item.final_line_price, 0);
        const baseTotal = cart.total_price - progressItemsTotal;

        setTimeout(function() {
          var element = document.querySelector('.progress-bar__bar .step:nth-child(5)');
          if (element) {
            var style = element.getAttribute('style');
            var match = style.match(/--var-percent:\s*(\d+)/);
            if (match) {
              var percentValue = parseInt(match[1], 10);
              if (percentValue < 100) {
                element.setAttribute('style', `--var-percent:${percentValue - 22}%`);
              }
            }
          }
        }, 2500);

        const itemsToRemove = [];
        stepData.forEach(step => {
          const progressItem = progressItems.find(item => item.id.toString() === step.id);
          if (baseTotal < step.threshold && progressItem) {
            itemsToRemove.push(progressItem.key);
          }
        });

        if (itemsToRemove.length > 0) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              updates: Object.fromEntries(itemsToRemove.map(key => [key, 0]))
            })
          });
        }

        // BIS: above the highest threshold and at least one gift in the cart -> make sure ALL gifts are in the cart (both directions).
        const sorted = stepData.slice().sort((a, b) => a.threshold - b.threshold);
        const top = sorted[sorted.length - 1];
        if (top && sorted.length > 1 && baseTotal >= top.threshold) {
          const inCart = step => cartItems.some(item => item.id.toString() === step.id);
          if (sorted.some(inCart)) {
            const missing = sorted.filter(step => !inCart(step));
            if (missing.length > 0) {
              return fetch(`${window.Shopify.routes.root}cart/add.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  items: missing.map(step => ({ id: Number(step.id), quantity: 1, properties: { _added_by: 'progress_bar' } }))
                })
              });
            }
          }
        }
      })
      .then(() => {
        theme.addedToCartHandler()
        this.renderProgress();
      })
      .catch(console.error);
  }

  disconnectedCallback() {
  }
}

customElements.define('ts-progress', TsProgress);

window.onload = function() {
  var element = document.querySelector('.progress-bar__bar .step:nth-child(5)');
  if (element) {
    var style = element.getAttribute('style');
    var match = style.match(/--var-percent:\s*(\d+)/);
    if (match) {
      var percentValue = parseInt(match[1], 10);
      if (percentValue < 100) {
        element.setAttribute('style', `--var-percent:${percentValue - 22}%`);
      }
    }
  }
}